import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { FreespinsModel } from "./FreespinsModel";
import { BaseView } from "../Base/BaseView";
import { BaseController } from "../Base/BaseController";

@engineComponent(ComponentTypes.Controller)
export class FreespinsController extends BaseController {
    constructor() {
        super();
    }

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof BaseView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of BaseView");
            }
        }

        this._model = new FreespinsModel(this);
    }

    startConfigurator(): void {
        this._view.startConfigurator();
        this.emit(FreespinsController.ConfiguratorStart);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsController.ts
 **/